import './App.css';
import Profile from './components/Profile';
import 'semantic-ui-css/semantic.min.css'
function App() {
  return (
    <div className="App">
      <Profile/>
    </div>
  );
}

export default App;
